import { useState } from "react"
import { Button, ModalBody, Modal, ModalContent, ModalHeader, ModalOverlay, Input, ModalCloseButton, Text, InputGroup, InputRightElement } from "@chakra-ui/react"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { toast } from 'react-hot-toast'
import api from "../../api"
import { useDispatch } from "react-redux"
import { getUsers } from "../../actions/userActions"

const validationSchema = Yup.object().shape({
    name: Yup.string().min(2).required("El nombre es requerido"),
    email: Yup.string().email("El email no es válido").required("El email es requerido"),
    password: Yup.string().min(6, 'Mínimo 6 caracteres'),
    confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden"),
    slots: Yup.number().min(1).required("El número de slots es requerido"),
    productsSlots: Yup.number().min(1).required("El número de slots de productos es requerido"),
})

const EditUserModal = ({onClose, isOpen, userInfo}) => {
    const [showPassword, setShowPassword] = useState(false)
    const dispatch = useDispatch()

    const handlePasswordClick = () => {
        setShowPassword(!showPassword)
    }

    const createUserRequest = async (values) => {
        try{
            const { data } = await api.put(`/users/${userInfo._id}`, values)
            return [true, data]
        }catch(error){
            console.log(error)
            return [false, error]
        }
    }

    const handleSubmit = async (values, {setSubmitting}) => {
        try{
            const [ok, res] = await createUserRequest(values)
            console.log(res)
            if(!ok) throw new Error()
            toast.success("Usuario creado con éxito.")
            setSubmitting(false)
            dispatch(getUsers({ page: 1, limit: 10 }))
            onClose()
        }catch(error){
            console.log(error)
            toast.error("Algo salió mal, inténtalo más tarde.")
            onClose()
        }
    }

    if(!userInfo) return null

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="xl"
        >
            <ModalOverlay />
            <Formik
                initialValues={{
                    name: userInfo.name,
                    email: userInfo.email,
                    password: "",
                    confirmPassword: "",
                    slots: userInfo.slots,
                    productsSlots: userInfo.productsSlots
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    errors,
                    dirty,
                    isValid,
                    isSubmitting,
                    handleSubmit,
                }) => (
                    <ModalContent>
                        <ModalHeader>
                            Nuevo Usuario
                            <ModalCloseButton />
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={handleSubmit}
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px"
                                }}
                            >
                                <Input
                                    name="name"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name}
                                />
                                {errors.name && <Text fontSize='small' color='red.500' >{errors.name}</Text>}
                                <Input
                                    name="email"
                                    label="Email"
                                    placeholder="Email"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.email}
                                />
                                {errors.email && <Text fontSize='small' color='red.500' >{errors.email}</Text>}
                                <InputGroup size='md'>
                                    <Input
                                        pr='4.5rem'
                                        type={showPassword ? 'text' : 'password'}
                                        name="password"
                                        label="Contraseña"
                                        placeholder="Contraseña"
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.password}
                                    />
                                    <InputRightElement width='4.5rem'>
                                        <Button h='1.75rem' size='sm' onClick={handlePasswordClick}>
                                        {showPassword ? 'Hide' : 'Show'}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                                {errors.password && <Text fontSize='small' color='red.500' >{errors.password}</Text>}
                                <Input
                                    name="confirmPassword"
                                    type={"password"}
                                    label="Confirmar Contraseña"
                                    placeholder="Confirmar Contraseña"
                                    value={values.confirmPassword}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.confirmPassword}
                                />
                                {errors.confirmPassword && <Text fontSize='small' color='red.500' >{errors.confirmPassword}</Text>}

                                <Text fontSize='small' color='gray.500' >
                                    Slots
                                </Text>
                                <Input
                                    name="slots"
                                    label="Slots"
                                    placeholder="Slots"
                                    value={values.slots}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.slots}
                                    type="number"
                                />
                                {errors.slots && <Text fontSize='small' color='red.500' >{errors.slots}</Text>}
                                <Text fontSize='small' color='gray.500' >
                                    Slots de productos
                                </Text>
                                <Input
                                    name="productsSlots"
                                    label="Slots de productos"
                                    placeholder="Slots de productos"
                                    value={values.productsSlots}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.productsSlots}
                                    type="number"
                                />
                                {errors.productsSlots && <Text fontSize='small' color='red.500' >{errors.productsSlots}</Text>}
                                <Button
                                    type="submit"
                                    colorScheme="facebook"
                                    mt={4}
                                    isLoading={isSubmitting}
                                    disabled={
                                        !dirty 
                                        || !isValid
                                        || isSubmitting
                                    }
                                    onClick={handleSubmit}
                                    mb='20px'
                                >
                                    Guardar
                                </Button>
                            </Form>
                        </ModalBody>
                    </ModalContent>
                )}
            </Formik>
        </Modal>
    )
}

export default EditUserModal